<template>
    <div class="col-md-6 m-b">
        <div v-bind:class="[error,'form-group']">
            <label>{{ name }}</label>
            <input type="text" :name="'dynamic_field_'+id" :title="name" v-model="value_inner" class="form-control">
        </div>
    </div>
</template>

<script>
    export default {
        props: ['id', 'name', 'value', 'error'],
        data: function() {
            return {
                value_inner: this.value
            }
        },
        watch: {
            value_inner: function(val,oldVal){
                this.$emit('input',val);
            }
        }
    }
</script>
